import { render, staticRenderFns } from "./ModalAddEditDistribution.vue?vue&type=template&id=99e71ace&scoped=true"
import script from "./ModalAddEditDistribution.vue?vue&type=script&lang=js"
export * from "./ModalAddEditDistribution.vue?vue&type=script&lang=js"
import style0 from "./ModalAddEditDistribution.vue?vue&type=style&index=0&id=99e71ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e71ace",
  null
  
)

export default component.exports